import { useRef } from "react";
import { useCanvasTemplate } from "../../../hooks/useCanvasTemplate";
import "./CreativeCanvas.css"

export function CreativeCanvas(props) {
  const canvas = useRef(null);

  useCanvasTemplate({ ...props, canvas });

  return (
    <div id="creativeCanvas">
      <canvas ref={canvas} height="1080" width="1080" className="canvasInner" />
    </div>
  );
}
